import React, { useEffect, useState } from "react";
import { Grid, Accordion, AccordionSummary, AccordionDetails, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import { FiChevronDown } from "react-icons/fi";
import useStyles from "./styles";
import TextInput from "Components/TextInput";
import Spinner from "Components/Spinner";
import actions from "store/actions";
import ls from "Localization";
import { State } from "store/reducers";
import { useNavigate } from "react-router-dom";
import { CompanyCreateState } from "store/reducers/company/create";
import { CODE } from "Components/NumberFormat";

function CompanyCreate() {
    const navigate = useNavigate();
    const dispatch = useDispatch<any>();
    const classes = useStyles({});

    const [showInfoPanel, setShowInfoPanel] = useState(true);

    useEffect(() => {
        dispatch(actions.company.create.clearValues());
    }, [dispatch]);

    const { loading, errors, businessName, socialName, cnpj, code } = useSelector<State, CompanyCreateState>(
        s => s.companyCreate
    );

    const handleChange = (id: string, value: any) => {
        const v = { [id]: value };
        dispatch(actions.company.create.setValue(v));
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        dispatch(
            actions.company.create.createCompany(err => {
                if (err) {
                    if ((err as any).code) alert((err as any).code);
                    else if (typeof err === "string") alert(err as any);
                    else alert(JSON.stringify(err));
                } else {
                    navigate("/Dashboard/Company");
                }
            })
        );
    };

    return (
        <form onSubmit={handleSubmit} noValidate>
            <Helmet>
                <title>
                    {"Criar empresa"} | {ls.appName}
                </title>
            </Helmet>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Accordion
                        TransitionProps={{ unmountOnExit: true }}
                        expanded={showInfoPanel}
                        onChange={() => setShowInfoPanel(prev => !prev)}
                    >
                        <AccordionSummary
                            expandIcon={<FiChevronDown />}
                            aria-controls="finishes-content"
                            id="finishes-header"
                        >
                            <Typography className={classes.heading} variant="h6">
                                {"Criar empresa"}
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <TextInput
                                        errors={errors}
                                        id="businessName"
                                        name="businessName"
                                        value={businessName ?? ""}
                                        required
                                        onChange={handleChange}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <TextInput
                                        errors={errors}
                                        id="socialName"
                                        name="socialName"
                                        value={socialName ?? ""}
                                        required
                                        onChange={handleChange}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <TextInput
                                        errors={errors}
                                        id="cnpj"
                                        name="cnpj"
                                        value={cnpj ?? ""}
                                        required
                                        onChange={handleChange}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                    <TextInput
                                        errors={errors}
                                        id="code"
                                        name="code"
                                        value={code ?? ""}
                                        required
                                        onChange={handleChange}
                                        InputProps={{
                                            inputComponent: CODE
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>

                <Grid item xs={12}>
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Button disabled={loading} variant="contained" color="secondary" type="submit">
                                {ls.save}
                                {loading && <Spinner size={20} style={{ marginLeft: 16 }} />}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
}

export default CompanyCreate;
